<template>
  <div></div>
</template>
<script>
import axiosWrapper from '@/utils/request'

export default {
  mounted() {
    this.$mpTrack('Error page mounted')
    const query = this.$route.query.test || this.$route.params.test
    if (query === 'application') {
      throw new Error('testing sentry')
    }
    if (query === 'api') {
      this.simulateApiFailure()
    }
  },
  methods: {
    async simulateApiFailure() {
      console.log('simulateApiFailure ran!')

      try {
        // const res = axiosWrapper({ url: 'https://reqres.in/api/users/23' })
        const res = await axiosWrapper({
          url: 'https://reqres.in/api/login?name=steve',
          method: 'POST',
          headers: {
            'x-api-key': 'reqres-free-v1'
          },
          data: {
            email: 'peter@klaven'
          }
        })
        console.log(res)
        console.log('interceptor(fakeError) ran!')
      } catch (e) {
        console.log('API failure simulated.')
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
